import platform from "../../../util/platform";
const requestPasswordReset = (request) => {
    return (params) => {
        const path = `/app/account/recovery`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const processPasswordReset = (request) => {
    return (params) => {
        const path = `/app/account/recovery/reset`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const updatePassword = (request) => {
    return (params) => {
        const path = `/app/account/recovery/update`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const getOverview = () => {
    return (params) => {
        const path = `/app/accounts/overview`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getAll = () => {
    return (params) => {
        const path = `/app/accounts/all`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getAllForCohortGroup = (cohortGroupId) => {
    return (params) => {
        const path = `/app/accounts/all/cohort-group/${cohortGroupId}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getAllPaginated = (request) => {
    return (params) => {
        const query = platform.buildPaginatedQuery(request);
        const path = `/app/accounts/all/paginated?${query}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const update = (email, request) => {
    return (params) => {
        const path = `/app/account/update/email/${email}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const updateNotificationsChangePhoneNumber = (request) => {
    const path = `/app/account/update/notifications/phone-number`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const updateNotificationsTogglePhoneNumberAllowed = (request) => {
    const path = `/app/account/update/notifications/phone-number/allowed`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const updateNotificationsToggleEmailAllowed = (request) => {
    const path = `/app/account/update/notifications/email/allowed`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const updateNotificationsRequestVerifyPhoneNumber = (request) => {
    const path = `/app/account/update/notifications/phone-number/request-verify`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const updateNotificationsVerifyPhoneNumber = (request) => {
    const path = `/app/account/update/notifications/phone-number/verify`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const updateNotificationsRequestVerifyEmailAddress = (request) => {
    const path = `/app/account/update/notifications/email/request-verify`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const updateNotificationsVerifyEmailAddress = (request) => {
    const path = `/app/account/update/notifications/email/verify`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const userAccount = {
    requestPasswordReset,
    processPasswordReset,
    updatePassword,
    getOverview,
    getAll,
    getAllForCohortGroup,
    getAllPaginated,
    update,
    updateNotificationsChangePhoneNumber,
    updateNotificationsRequestVerifyPhoneNumber,
    updateNotificationsVerifyPhoneNumber,
    updateNotificationsTogglePhoneNumberAllowed,
    updateNotificationsRequestVerifyEmailAddress,
    updateNotificationsVerifyEmailAddress,
    updateNotificationsToggleEmailAllowed,
};
export default userAccount;
